var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
// import { SnippetHelper }  from '../../../helpers/snippetHelper';
// import { Locale, LanguageHelper } from '../../../helpers/languageHelper';
import { LanguageHelper } from '@pm-tt/common-components/lib/LanguageHelper';
import { SnippetHelper } from '@pm-tt/common-components/lib/SnippetHelper';
var LangDropdown = /** @class */ (function (_super) {
    __extends(LangDropdown, _super);
    function LangDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        // not using autobind! we don't write a function but add a variable
        _this.handleClick = function (event) {
            // console.log("we clicked");
            var myElement = _this.parentRef;
            // console.log("myElement:");
            // console.log(myElement);
            if (myElement.contains(event.target)) {
                // console.log("clicked inside");
                // the click is inside so continue to whatever we were doing before
                return;
            }
            // the click is outside, do something
            // console.log("clicked outside");
            _this.props.clickOutsideCallback(event);
        };
        _this.state = {
            dropdownItems: [],
            currentLang: ""
        };
        return _this;
    }
    LangDropdown.prototype.componentDidMount = function () {
        var _this = this;
        this._isMounted = true;
        // put the getsnippet in here
        var currentLocale = LanguageHelper.getCurrentLocale();
        // console.log(currentLocale);
        this.setState({
            currentLang: currentLocale.Language
        });
        SnippetHelper.getSnippet("#langdropdown").then(function (snippets) {
            if (snippets.length > 0 && _this._isMounted) {
                // console.log(snippets);
                _this.setState({
                    dropdownItems: snippets
                });
            }
        });
        if (!this.props.isTablet) {
            document.addEventListener('click', this.handleClick, false);
        }
    };
    LangDropdown.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        // console.log("unmount");
        if (!this.props.isTablet) {
            document.removeEventListener('click', this.handleClick, false);
        }
    };
    LangDropdown.prototype.componentDidUpdate = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // console.log("property changed");
                // console.log(nextProps);
                if (nextProps.isTablet != this.props.isTablet) {
                    // console.log("isTablet has changed");
                    // this.setState({
                    //     isTablet: nextProps.isTablet
                    // });
                }
                if (nextProps.componentWidth != this.props.componentWidth) {
                    // console.log("componentWidth has changed");
                    // this.setState({
                    //     componentWidth: nextProps.componentWidth
                    // });
                }
                return [2 /*return*/];
            });
        });
    };
    LangDropdown.prototype.render = function () {
        var _this = this;
        if (this.props.isTablet) {
            // if mobile nav, we have to set the width and height of the mobile nav dropdown
            this.mobileNavPanelStyle = {
                width: this.props.componentWidth + 'px',
                height: this.props.componentHeight + 'px',
                left: this.props.componentWidth + 'px'
            };
        }
        else {
            this.mobileNavPanelStyle = {};
        }
        var dropdownItems = null;
        dropdownItems = this.state.dropdownItems.map(function (dropdownItem, i, arr) {
            return React.createElement("li", { key: i, id: dropdownItem.snippet, className: _this.state.currentLang == dropdownItem.snippet.substr(14) ? "selected" : "" },
                React.createElement("a", { tabIndex: 0, href: dropdownItem.url.url, onKeyDown: function (e) { return _this.processKeyPress(i, arr, e); } }, dropdownItem.url.description));
        });
        var dropdownList = React.createElement("ul", null,
            this.props.isTablet && (React.createElement("li", null,
                React.createElement("button", { tabIndex: 0, ref: function (el) { return _this.backButtonRef = el; }, className: "dropdownBack", onKeyDown: function (e) { return _this.processKeyPress(-1, null, e); }, onClick: function (e) { return _this.props.clickBackCallback(e); } }, "Back"))),
            dropdownItems);
        return (React.createElement("div", { id: "langdropdown", className: "utilityNavDropdown", style: this.mobileNavPanelStyle, ref: function (el) { return _this.parentRef = el; } }, dropdownList));
    }; // end render()
    LangDropdown.prototype.processKeyPress = function (i, arr, e) {
        // if back button
        if (i === -1) {
            if (this.props.isTablet) {
                // we want to go back to the search button if in mobile
                if (e.keyCode == 9 && e.shiftKey) {
                    // console.log("backwards");
                    document.getElementById("toggleSearch").focus();
                    e.preventDefault();
                }
            }
        }
        if (arr) {
            // if first item in desktop, backwards tab closes the dropdown
            if (i === 0) {
                if (e.keyCode == 9 && e.shiftKey && !this.props.isTablet) {
                    // focus back on parent
                    var parentFocus = document.getElementById("utilityLanguageButton");
                    parentFocus.focus();
                    e.preventDefault();
                    this.props.clickOutsideCallback(e);
                }
            }
            // if last item
            if (i === arr.length - 1) {
                if (e.keyCode == 9 && !e.shiftKey) {
                    if (this.props.isTablet) {
                        // we want to return to the top of the #langdropdown element in mobile
                        this.backButtonRef.focus();
                        e.preventDefault();
                    }
                    else {
                        // we want the dropdown to close when you tab past in desktop
                        this.props.clickOutsideCallback(e);
                    }
                }
            }
        }
    };
    return LangDropdown;
}(React.Component));
export { LangDropdown };
